// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import Buefy from 'buefy'
import GetTextPlugin from 'vue-gettext'
import moment from 'moment'
import axios from 'axios'
import Vuelidate from 'vuelidate'
import VueHead from 'vue-head'
import * as Cookies from 'js-cookie'

import createRouter from './router'
import store from './store'
import translations from './translations/translations.json'

import EntityDetails from '@/components/EntityDetails'
import EntityCreateForm from '@/components/form/EntityCreateForm'

import { dateFormatter, ToastError, isLowerVersion } from '@/utils'

Vue.config.productionTip = false

moment.locale('de')

Vue.use(Vuelidate)
Vue.use(VueHead)

Vue.use(Buefy, {
  defaultIconPack: 'fa',
  defaultDateFormatter: dateFormatter,
  defaultDateParser: date => {
    const m = moment(date, 'DD.MM.YYYY')
    return m.isValid() ? m.toDate() : null
  },
  defaultMonthNames: moment.months(),
  defaultDayNames: moment.weekdaysMin(),
  defaultFirstDayOfWeek: 1
})

Vue.use(GetTextPlugin, {
  translations: translations,
  availableLanguages: {
    de_DE: 'DE',
    en_150: 'EN'
  },
  defaultLanguage: 'de_DE'
})

const leurisConfig = window.LEURIS_CONFIG || { MODE: 'FOB' }
const leurisMode = leurisConfig.MODE

Vue.prototype.$leurisMode = leurisMode

Vue.component('fob-entity-details', EntityDetails)
Vue.component('fob-entity-create-form', EntityCreateForm)

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router: createRouter(leurisMode),
  store,
  template: '<App/>',
  components: {
    App
  },
  methods: {
    checkUserToken () {
      if (store.getters['user/isAuthorized']) {
        if (store.getters['user/remainingSessionLength'] <= 0) {
          ToastError(this.$gettext(`toast.session.expired`))
          store.dispatch('user/logout')
          this.$router.replace({name: 'welcome'})
        } else if (store.getters['user/remainingSessionLength'] < 10 * 60 * 1000) {
          ToastError(this.$gettext(`toast.session.will.expired.soon`))
        }
      }
    },
    checkForUpdate () {
      axios
        .get('/static/data/version.json')
        .then(response => {
          const clientVersion = store.getters['getVersion']
          const serverVersion = response.data.version
          if (clientVersion !== serverVersion) {
            store.dispatch('setServerVersion', serverVersion)
            this.$snackbar.open({
              indefinite: false,
              duration: 10000,
              message: this.$gettext('UpdateAvailable'),
              type: 'is-info',
              position: 'is-bottom-right',
              actionText: this.$gettext('ReloadPage'),
              queue: false,
              onAction: () => {
                console.log('ok')
                // reload page
                window.location.reload(true)
              }
            })
          }
        })
    }
  },
  mounted () {
    // set language on start
    Vue.config.language = store.getters['language']

    store.dispatch('start')
    // this.checkUserToken()
    this.checkForUpdate()
    /*
    // user token
    setInterval(() => {
      this.checkUserToken()
    }, 60 * 1000) // every 60 seconds
    */

    // version
    setInterval(() => {
      this.checkForUpdate()
    }, 60 * 60 * 1000) // every hour

    if (store.state.lastVersion === '') {
      store.dispatch('updateLastVersion', store.state.version)
    }

    // this triggers deletion of the local storage when a schema change has
    // occured. the version number in the if condition below represents the
    // version number of the latest schema change.
    // for every user with a version number below that version the local
    // storage needs to be deleted
    if (store.state.lastVersion !== store.state.version && isLowerVersion(store.state.lastVersion, 'v0.43.0')) {
      console.log('Dropping browser cache')
      let fobStorage = window.localStorage.getItem('de.ul.fob')
      let fobJSON = JSON.parse(fobStorage)
      delete fobJSON.list
      fobJSON.lastVersion = store.state.version
      store.dispatch('updateLastVersion', store.state.version)
      Cookies.remove(process.env.COOKIE_KEY_MACO, {
        path: '',
        domain: process.env.COOKIE_DOMAIN
      })
      window.localStorage.removeItem('de.ul.fob')
      window.localStorage.setItem('de.ul.fob', JSON.stringify(fobJSON))
      // store.dispatch('user/logout').then(() => this.$router.push('/login'))
      location.reload()
    }
  }
})



// WEBPACK FOOTER //
// ./src/main.js